import axios from "@/http"
export default {
  name:"commonIndex",
  //短信验证码
  sendLetterCode(data){
    return axios({
      method:'GET',
      url:"/api/v1/user/verification/code",
      params:data
    })
  },
  //获取用户信息
  getUserInfo(param){
    return axios({
      method:"GET",
      url:"/api/v1/user/users",
      params:{
        preload:true,
        uuid:param.uuid
      }
    })
  },
  //登录
  doLogin(data){
    return axios({
      method:"POST",
      url:"/api/v1/user/session",
      params:data
    })
  },
  //学校列表
  listSchool (param) {
    return axios({
      method: "GET",
      url: '/api/v1/common/schools',
      params: param
    })
  },
  //专业列表
  listMajor(query) {
    return axios({
      url: '/api/v1/common/majors',
      method: 'get',
      params: query
    })
  },
  //注册
  register(param){
    return axios({
      method:"POST",
      url:"/api/v1/user/registers",
      params:{
        nickname: param.nickName,
        avatar:param.avatar,
        mobile:param.phone,
        school_id:param.school_id,
        academy_id:param.academy_id
      }
    })
  },
  //学院列表
  listAcademys(param){
    return axios({
      method:'GET',
      url:'/api/v1/common/academys',
      params:param
    })
  },
  refresh(param){
    return axios({
      method:'POST',
      url:"/api/v1/user/refresh",
      data:param
    })
  },
  logs(param){
    return axios({
      method:'POST',
      url:"/api/backstage/v1/sys/Logs",
      data:param
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/common/axj-common-index-api.js